"use client";

import React from "react";
const steps = [{
  number: "01",
  title: "Tell Me Your Vision",
  description: "Share your must-haves, budget, and target neighborhoods like Aurora or Plainfield through our quick lead form.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/step_1_vision.png"
}, {
  number: "02",
  title: "I Curate The List",
  description: "Our local experts manually filter through current listings to find high-value homes specifically under the $650K mark.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/step_2_curation.png"
}, {
  number: "03",
  title: "Check Your Inbox",
  description: "Receive a personalized selection of the best off-market and hot properties delivered straight to your email within 24 hours.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/step_3_delivery.png"
}, {
  number: "04",
  title: "Start Your Journey",
  description: "Review your curated options and schedule private viewings for the homes that feel like the perfect fit for your family.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638281/img/step_4_viewing.png"
}];
function StepCard({
  step
}: {
  step: typeof steps[0];
}) {
  return <div data-section-id="223307" className="flex flex-col gap-6 w-full items-center text-center group">
      <div className="relative overflow-hidden rounded-lg border border-emerald-100 shadow-sm group-hover:border-emerald-500/40 transition-colors duration-500 bg-white/80">
        <img src={step.image} data-wvc-srcset={`${step.image}-wvc-srcset`} data-wvc-sizes={`${step.image}-wvc-sizes`} alt={step.title} loading="lazy" className="w-[240px] h-[160px] object-cover transition-transform duration-700 group-hover:scale-105 opacity-95 group-hover:opacity-100" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/10 to-transparent opacity-40 mix-blend-multiply pointer-events-none" />
      </div>
      <div className="flex flex-col gap-2 items-center">
        <div className="text-emerald-600 font-default text-xs font-bold tracking-[0.2em] uppercase flex items-center gap-2">
          Step {step.number}
        </div>
        <h3 className="font-default text-2xl font-bold text-slate-800 tracking-tight">{step.title}</h3>
        <p className="font-sans text-slate-600 text-sm md:text-base leading-relaxed max-w-[280px]">{step.description}</p>
      </div>
    </div>;
}
export default function TheDirectorsPath() {
  return <section id="how-it-works" className="bg-slate-50 text-slate-900 py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-emerald-500/5 rounded-full blur-[120px] pointer-events-none -translate-x-1/2" />
      <div className="absolute bottom-1/4 right-0 w-[400px] h-[400px] bg-emerald-500/5 rounded-full blur-[100px] pointer-events-none translate-x-1/2" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        
        <div className="text-center max-w-3xl mx-auto mb-20 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 tracking-tighter">
            How It Works
          </h2>
          <p className="font-sans text-slate-600 text-lg md:text-xl leading-relaxed">
            A simple, transparent three-step process to find your dream home in the suburbs without the Naperville price tag.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {steps.slice(0, 3).map((step, i) => <div key={i} data-index={i}>
                <StepCard step={step} />
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}